'use client'

import {observer} from 'mobx-react'

import {PageType} from '@/src/core/domain/entities/page'

import {VideoPagination} from '@/src/(pages)/video/pagination'
import {VideoContent} from '@/src/(pages)/video/screen.page'

import {useStore} from '@/src/shared/hooks/useStore'
import {LayoutMeta} from '@/src/shared/ui/layout/ui/meta'
import {PageTitle} from '@/src/shared/ui/layout/ui/page-title'
import {LayoutUI} from '@/src/shared/ui/layout/ui/styles'

export const VideoReviewsMeta = observer(() => {
  const {pageData} = useStore<VideoContent>()

  let title: React.ReactNode = ''

  if (pageData!.type === PageType.VideoReviewList) {
    title = (
      <>
        <h1>Видеообзоры</h1>
        {pageData!.content.video_reviews.pages > 1 && <VideoPagination key="video-pagination" />}
      </>
    )
  }

  return <LayoutUI.Meta as={LayoutMeta} title={<PageTitle>{title}</PageTitle>} breadcrumbs={pageData!.breadcrumbs} />
})
